module.exports = __webpack_public_path__ + "static/media/merriweather-italic-webfont.5b09f197.eot";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/merriweather-italic-webfont.eot
// module id = 290
// module chunks = 0